import styled from 'styled-components'
import {
  MenuItem
} from 'components/Sidebar'

const LayoutGroupItem = styled(MenuItem)`
  padding: 5px 0;
`

export default LayoutGroupItem